<template>
    <div :class="['conference', { noimage: !conference.cover }]">
        <div class="cover" v-if="conference.cover">
            <div class="filler"></div>
            <Image :image="conference.cover" :width="236" :height="200" :mobileHeight="700" imageClass="cover" />
        </div>
        <div class="info">
            <LazyNeverItemConferenceDateRange :conference="conference" hydrate-never />
            <div class="helvetica title4">{{ conference.title }}</div>
            <div class="baron headerText" v-if="conference.location">{{ conference.location.toLowerCase() }}</div>
        </div>
        <div class="plusCont">
            <IconPlus />
        </div>
        <NuxtLink class="overlink" :to="{ name: 'conferences-slug', params: { slug: conference.url } }" :aria-label="conference.title"></NuxtLink>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ conference: any }>()
</script>

<style lang="scss" scoped>
.conference {
    position: relative;
    display: grid;
    grid-template-rows: min-content 1fr min-content;
    gap: var(--size-gutter-default);
    padding: var(--size-gutter-default);

    background-color: var(--color-sand);
    color: var(--color-primary);

    .cover {
        width: 100%;
        background-color: #fafafa;
        position: relative;

        filter: saturate(0);
        mix-blend-mode: multiply;

        .filler {
            padding-top: 84.75%;
        }

        &:deep(.responsivePicture) {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        gap: var(--size-gutter-small);

        .date {
            color: var(--color-text);
        }
        .title4 {
            text-wrap: balance;
        }
    }

    .plusCont {
        display: flex;
        justify-content: flex-end;
    }

    &.noimage {
        grid-template-rows: 1fr min-content;
    }
}
</style>